import { render } from "./JobsGrid.vue?vue&type=template&id=066b0d6e&scoped=true"
import script from "./JobsGrid.vue?vue&type=script&lang=js"
export * from "./JobsGrid.vue?vue&type=script&lang=js"

import "./JobsGrid.vue?vue&type=style&index=0&id=066b0d6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066b0d6e"]])

export default __exports__